import { Injectable } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { AddSourceModalComponent } from './add-source-modal.component';

@Injectable()
export class AddSourceModalService {

    constructor(
        private readonly dialog: MatDialog
    ) { }

    showModal(): MatDialogRef<AddSourceModalComponent> {

        return this.dialog.open<AddSourceModalComponent>(
            AddSourceModalComponent,
            { disableClose: true }
        );

    }
}
